import * as React from "react";
import styled from "styled-components";
import { Field } from "formik";
import { Icon, HoverForHelp } from "components/common";
import { TimeUnits } from "views/Constants";
import { FormControl, Checkbox, MenuItem, InputGroup, Input } from "components/bootstrap";
import DropdownButton from "components/bootstrap/DropdownButton";
const RangeSelect = styled.div`
  display: flex;
  align-items: center;
`;
const CurrentScale = styled.div`
  min-width: 30px;
  margin-left: 5px;
  text-align: right;
`;
const TypeCheckboxWrapper = styled.div`
  margin-bottom: 5px;
`;
const IntervalCheckboxDescWithHelp = styled.div`
  display: flex;
  align-items: center;
`;
const IntervalHoverForHelp = styled(HoverForHelp)`
  margin-left: 5px;
`;
const IntervalCheckboxDesc = () => /* @__PURE__ */ React.createElement(IntervalCheckboxDescWithHelp, null, "Auto", /* @__PURE__ */ React.createElement(IntervalHoverForHelp, { title: "Interval Types" }, /* @__PURE__ */ React.createElement("ul", null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("h4", null, "Auto bucket size"), "For example, 1.5x. A smaller granularity leads to ", /* @__PURE__ */ React.createElement("strong", null, "less"), "; conversely, a larger one shows", " ", /* @__PURE__ */ React.createElement("strong", null, "more"), " values."), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("h4", null, "Fixed bucket size"), "For example, 2 minutes. The time defines the size of the buckets for this timestamp type."))));
const toggleIntervalType = (name, currentType, onChange) => {
  if (currentType === "auto") {
    onChange({ target: { name, value: { type: "timeunit", value: 1, unit: "minutes" } } });
  } else {
    onChange({ target: { name, value: { type: "auto", scaling: 1 } } });
  }
};
const StyledFormControl = styled(FormControl)`
  padding: 0;
  border: 0;
`;
const Time = ({ index }) => /* @__PURE__ */ React.createElement(Field, { name: `groupBy.groupings.${index}.interval` }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(
  Input,
  {
    id: "group-by-interval",
    label: "Interval",
    error,
    labelClassName: "col-sm-3",
    wrapperClassName: "col-sm-9"
  },
  /* @__PURE__ */ React.createElement(TypeCheckboxWrapper, null, /* @__PURE__ */ React.createElement(Checkbox, { onChange: () => toggleIntervalType(name, value.type, onChange), checked: value.type === "auto" }, /* @__PURE__ */ React.createElement(IntervalCheckboxDesc, null))),
  value.type === "auto" && /* @__PURE__ */ React.createElement(RangeSelect, null, /* @__PURE__ */ React.createElement(Icon, { name: "zoom_out", size: "lg", style: { paddingRight: "0.5rem" } }), /* @__PURE__ */ React.createElement(
    StyledFormControl,
    {
      type: "range",
      min: 0.5,
      max: 10,
      step: 0.5,
      value: value.scaling ? 1 / value.scaling : 1,
      onChange: (e) => onChange({
        target: { name, value: { ...value, scaling: 1 / parseFloat(e.target.value) } }
      })
    }
  ), /* @__PURE__ */ React.createElement(Icon, { name: "zoom_in", size: "lg", style: { paddingLeft: "0.5rem" } }), /* @__PURE__ */ React.createElement(CurrentScale, null, value.scaling ? 1 / value.scaling : 1, "x")),
  value.type !== "auto" && /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(
    FormControl,
    {
      type: "number",
      value: value.value,
      step: "1",
      min: "1",
      onChange: (e) => onChange({ target: { name, value: { ...value, value: e.target.value } } })
    }
  ), /* @__PURE__ */ React.createElement(InputGroup.Button, null, /* @__PURE__ */ React.createElement(DropdownButton, { title: TimeUnits[value.unit] || "" }, Object.keys(TimeUnits).map((unit) => /* @__PURE__ */ React.createElement(MenuItem, { key: unit, onSelect: () => onChange({ target: { name, value: { ...value, unit } } }) }, TimeUnits[unit])))))
));
export default Time;
